const carRental = {
  carRental: "Sewa Kereta", // translated 
  carRentals: "Sewaan Kereta", // translated 
  pickUpPoint: "Tempat Pengambilan", // translated 
  dropOffPoint: "Titik Turun", // translated 
  pleaseSelectAPickUpPoint: "Sila pilih Tempat Pengambilan", // translated 
  pickUpDate: "Tarikh Pengambilan", // translated 
  dropOffDate: "Tarikh Penghantaran", // translated 
  pickUp: "Pengambilan", // translated 
  dropOff: "Penghantaran", // translated 
  edit: "Sunting", // translated 
  fuelPolicy: "Dasar Bahan Api", // translated 
  pickUpLocation: "Lokasi Pengambilan", // translated 
  mileage: "Jarak tempuh", // translated 
  transmission: "Penularan", // translated 
  airCondition: "Penghawa Dingin", // translated 
  minimumAge: "Umur Minimum", // translated 
  maximumAge: "Umur Maksimum", // translated 
  providerAddress: "Alamat Pembekal", // translated 
  providerPhone: "Telefon Pembekal", // translated 
  driverInfo: "Maklumat Pemandu", // translated 
  driversInfo: "Maklumat Pemandu", // translated 
  differentDropOff: "Penghantaran di lokasi yang berbeza", // translated 
  maxPassengers: "Penumpang Maksimum", // translated 
  budget: "Bajet", // translated 
  provider: "Pembekal", // translated 
  carModel: "Model Kereta", // translated 
  numOfDoors: "Bilangan Pintu", // translated 
  fuelType: "Jenis Bahan Api", // translated 
  driverAge: "Umur Pemandu", // translated 
  enterValidDriversAge: "Sila masukkan Umur Pemandu yang sah.", // translated 
  workingHours: "Waktu Bekerja", // translated 
  driverNationality: "Kewarganegaraan Pemandu", // translated 
  nationalityIsRequired: "Kewarganegaraan diperlukan", // translated 
  carRentalRate: "Kadar Sewa Kereta", // translated 
  dueNow: "Tarikh Luput Sekarang", // translated 
  duePickUp: "Perlu dibayar semasa pengambilan", // translated 
  toViewOfferPDF:
    "Untuk melihat dokumen PDF yang mengandungi semua terma sewaan tawaran ini, sila", // translated 
  toViewTermsAndCondPDF:
    "Untuk melihat Terma dan Syarat CARNECT yang berkenaan, sila", // translated 
  carRentalsNotFound:
    "Kami tidak dapat menemui sebarang hasil Sewaan Kereta. Kami memohon maaf atas kesulitan ini.", // translated 
};








export default carRental;
